export class ActionCreatePermissions {
    HasVisitaMedico = false;
    HasVisitaGestion = false;
    HasCreateVisita = false;
    HasCreateVisitaAusente = false;
    HasCreateContacto = false;
    HasCreateContactoFallido = false;
    HasCreateContactoAdministrativo = false;
    HasCreateContactoAdministrativoFallido = false;
    HasCreateGestionConMutua = false;
    HasCreateSolicitud = false;
    HasCreateInformeMedico = false;
    HasCreateDocumentoNoMedico = false;
    HasCreateComentario = false;
    HasCreateOrden = false;
    HasPermit607 = false;
    HasPermit627 = false;
}
